import React from 'react';
import './Chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function Chapter5() {
  const hyperlinkData = [
    {
      href: 'https://carttogether.com/?utm_source=CNN&utm_medium=LinkedIn&utm_campaign=CARTTogether+',
      copy: 'CAR T Together'
    }
  ];
  return (
    <section className="chapter">
      <h3 className="chapter-title">Bringing the Future Forward for CAR T</h3>
      <p className="chapter-paragraph">
        To reduce the bottleneck and accelerate access to CAR Ts, oncologists from preeminent
        research institutions nationwide have joined forces to move cancer treatment forward. The
        result is <Hyperlink hyperlinkData={hyperlinkData[0]} />, a first-of-its-kind effort to
        bring together investigators who are committed to supporting the development of allogeneic
        CAR T products as a possible solution for expanding access for patients.
      </p>
      <p className="chapter-paragraph">
        Many of the physicians participating in CAR T Together were instrumental in advancing the
        development of autologous CAR T therapies. Now they’re turning their attention to what’s
        needed to speed the development of an “off-the-shelf” option—advancement of clinical trials.
      </p>
    </section>
  );
}

export default Chapter5;
